var _path, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOurDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 42,
    viewBox: "0 0 203 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.1324 28.1604C71.4324 28.1604 74.5324 25.0004 74.5324 20.7204C74.5324 16.4404 71.4324 13.2804 67.1324 13.2804C62.8324 13.2804 59.7324 16.4404 59.7324 20.7204C59.7324 25.0004 62.8324 28.1604 67.1324 28.1604ZM67.1324 26.6004C63.8124 26.6004 61.5324 23.9804 61.5324 20.7204C61.5324 17.4604 63.8124 14.8404 67.1324 14.8404C70.4524 14.8404 72.7324 17.4604 72.7324 20.7204C72.7324 23.9804 70.4524 26.6004 67.1324 26.6004ZM95.0521 13.6404H93.3721V22.1604C93.3721 24.4404 92.5321 26.6004 89.7121 26.6004C86.8921 26.6004 86.0521 24.4404 86.0521 22.1604V13.6404H84.3721V22.4004C84.3721 25.4804 85.8121 28.1604 89.7121 28.1604C93.6121 28.1604 95.0521 25.4804 95.0521 22.4004V13.6404ZM105.714 27.8004H107.394V21.4404H109.554L113.394 27.8004H115.454L111.434 21.2804C113.634 20.9404 114.974 19.6004 114.974 17.5404C114.974 14.0404 112.074 13.6404 109.334 13.6404H105.714V27.8004ZM107.394 15.2004H109.754C111.394 15.2004 113.174 15.5004 113.174 17.5404C113.174 19.8804 110.754 19.8804 108.894 19.8804H107.394V15.2004ZM124.881 27.8004H130.321C133.101 27.8004 137.261 25.9404 137.261 20.7204C137.261 15.5004 133.101 13.6404 130.321 13.6404H124.881V27.8004ZM126.561 15.2004H129.761C133.001 15.2004 135.461 16.8404 135.461 20.7204C135.461 24.6004 133.001 26.2404 129.761 26.2404H126.561V15.2004ZM145.525 27.8004H147.425L148.885 24.3204H155.965L157.405 27.8004H159.365L153.345 13.6404H151.765L145.525 27.8004ZM155.325 22.7604H149.545L152.485 15.8004H152.525L155.325 22.7604ZM176.111 13.6404H165.071V15.2004H169.751V27.8004H171.431V15.2004H176.111V13.6404ZM185.295 27.8004H194.555V26.2404H186.975V21.2004H193.715V19.6404H186.975V15.2004H194.195V13.6404H185.295V27.8004Z",
    fill: "#4A464F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_43970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7272 28.5247C24.0555 27.8677 23.508 27.1068 23.1046 26.2876C23.0416 26.1597 22.8836 26.1092 22.7596 26.1795C22.1795 26.5083 21.5797 26.8085 20.9622 27.0778L20.8274 27.1324C20.3146 27.3342 19.7723 27.4365 19.2134 27.4365C16.7869 27.4365 14.8128 25.4634 14.8128 23.0379C14.8128 20.6125 16.7869 18.6393 19.2134 18.6393C21.6393 18.6393 23.5729 20.5732 23.6159 23.0417C23.6195 23.2453 23.6333 23.4471 23.6568 23.6466C23.6774 23.8216 23.8777 23.9032 24.0188 23.7976C26.9844 21.5788 29.2187 18.4762 30.3617 14.8889C30.921 13.1335 31.2048 11.2995 31.2048 9.43758C31.2048 8.14936 31.0677 6.86648 30.7972 5.61917C30.7853 5.56416 30.7542 5.51523 30.7094 5.48111C27.681 3.17278 23.9022 1.80042 19.8089 1.80042C9.8789 1.80042 1.80035 9.8752 1.80035 19.8003C1.80035 29.7256 9.8789 37.8004 19.8089 37.8004C25.7167 37.8004 30.9689 34.942 34.2547 30.5364C34.4086 30.3301 34.153 30.0505 33.9185 30.1567C32.8751 30.6293 31.7213 30.8891 30.5181 30.8891C28.3427 30.8891 26.2862 30.0495 24.7272 28.5247Z",
    fill: "#50AFBF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_43970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8013 7.39627C32.6441 7.2317 32.3714 7.36567 32.3932 7.59223C32.4529 8.21175 32.483 8.83523 32.483 9.45995C32.483 11.4608 32.1778 13.4328 31.5763 15.321C30.2792 19.3921 27.6753 22.8823 24.2191 25.2878C24.1253 25.353 24.0887 25.4752 24.1362 25.5791C25.217 27.9421 27.7028 29.6492 30.4842 29.6492C33.5945 29.6492 36.3132 27.5896 37.1592 24.6183C37.5771 23.0975 37.8004 21.4975 37.8004 19.8459C37.8004 15.023 35.8968 10.6362 32.8013 7.39627Z",
    fill: "#50AFBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_43970",
    x: -0.00000834465,
    y: 0.0000526905,
    width: 36.1018,
    height: 39.6007,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.900181
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.770833 0 0 0 0 0.61808 0 0 0 0 0.584549 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_43970"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_43970",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_43970",
    x: 22.3151,
    y: 5.52276,
    width: 17.2857,
    height: 25.9269,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.900181
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.770833 0 0 0 0 0.61808 0 0 0 0 0.584549 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_43970"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_43970",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurDate);
export default __webpack_public_path__ + "static/media/OurDate.6af4b685ed1d785d37a2cb7194dbf477.svg";
export { ForwardRef as ReactComponent };